export default {
	login_access_description: 'Melden Sie sich mit Instanz, Benutzername, Passwort oder Sicherheitsschlüssel an.',
	login_access_secure_workspace: 'Sicher in Ihren Arbeitsbereich einloggen',
	login_add_account: 'Instanz hinzufügen',
	login_cancel: 'Abbrechen',
	login_data_protection: 'Datenschutz',
	login_hide_password: 'Passwort ausblenden',
	login_imprint: 'Impressum',
	login_instance: 'Instanzname oder URL',
	login_ip_restricted: 'Anmeldung von diesem Standort ist für diesen Benutzer nicht erlaubt.',
	login_login: 'Anmelden',
	login_login_add_webauthn_device: 'Schlüssel hinzufügen',
	login_login_webauthn: 'Mit Schlüssel Anmelden',
	login_login_webauthn_validate: 'Schlüssel überprüfen',
	login_only_letters_for_instance: 'Der Instanzname darf nur aus Zahlen und Buchstaben bestehen',
	login_password: 'Passwort',
	login_show_password: 'Passwort anzeigen',
	login_two_factor_authentication_code: '2FA Code',
	login_username: 'Benutzername',
	login_username_or_password_or_2fa_token_wrong: 'Benutzername, Passwort oder 2FA Code falsch',
	login_username_or_password_wrong: 'Benutzername oder Passwort falsch',
	login_valid_instance: 'Instanz erkannt',
	login_validate: 'Benutzername und Passwort prüfen',
	login_validate_failed: 'Fehlgeschlagen, erneut prüfen',
	login_validate_successful: 'Prüfung erfolgreich, Konto hinzufügen',
	login_webauthn_device_registration_failed: 'Die Schlüssel Registrierung war nicht erfolgreich',
	login_webauthn_device_registration_successful: 'Die SchlüsselRegistrierung wurde erfolgreich durchgeführt',
	login_webauthn_help: 'Hilfe zur Schlüssel-Anmeldung öffnen',
};
